import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import EventAbstract from '../../common/events/EventAbstract';

/**
 * SubNavToggleArrowUp
 *
 * Event action handler class.
 */
var SubNavToggleArrowUp = /*#__PURE__*/function (_EventAbstract) {
  _inherits(SubNavToggleArrowUp, _EventAbstract);
  var _super = _createSuper(SubNavToggleArrowUp);
  function SubNavToggleArrowUp() {
    _classCallCheck(this, SubNavToggleArrowUp);
    return _super.apply(this, arguments);
  }
  _createClass(SubNavToggleArrowUp, [{
    key: "exec",
    value:
    /**
     * Execute the action to the event.
     */
    function exec() {
      this.event.preventDefault();

      // If the current focus is on the toggle and the menu is expanded, close
      // this nav menu and go to the parent list item.
      if (this.parentNav.isExpanded()) {
        event.stopPropagation();
        event.preventDefault();
        this.parentNav.closeSubNav();
        this.getElement('parentItem').focus();
      }
      // If the focus is on the toggle and the menu is not expanded, go to the
      // previous sibling item by calling the super method.
      else {
        var node = this.getElement('prev') || this.getElement('parentNavPrev') || this.getElement('first');
        if (node) {
          node.focus();
        }
      }
    }
  }]);
  return SubNavToggleArrowUp;
}(EventAbstract);
export { SubNavToggleArrowUp as default };